import React from 'react';
import PropTypes from 'prop-types';
import { BdsTypo } from 'blip-ds/dist/blip-ds-react';
import { getFirstDayOfSpecifiedMonth, getLastDayOfSpecifiedMonth, toUTCDateString } from '../../../../../utils/date';
import { useContentLocalizer } from '../../../../../hooks/useContentLocalizer';
import { localization } from './localizations';
import { ConsolidatedBorder, ConsolidatedHeader, ConsolidatedEndInfo } from './styles';
import { ModalOpenButton } from '../../ConsumptionData/Header/styles';
import { CustomModal } from '../../ConsumptionData/Header/CustomModalComponent';

const ConsolidatedHeaderComponent = ({
  infoHeader,
  dateToSearch,
  currentMonth,
  middleInfoContent,
  endInfoContent,
  learnMore,
  modalContent,
  showConsolidatedBorder = true,
  filter1 = undefined,
  filter2 = undefined,
}) => {

  const modalTitle = modalContent?.title || '';
  const modalAction = modalContent?.action || 'Fechar';
  const modalDelivered = modalContent?.delivered || '';
  const modalPaids = modalContent?.paids || '';
  const modalFree = modalContent?.free || '';
  const modalEntryPoint = modalContent?.entryPoint || '';
  const modalService = modalContent?.service || '';

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [clickPosition, setClickPosition] = React.useState({ y: 0 });

  const handleLearnMoreClick = (event) => {
    setClickPosition({ y: event.clientY });
    setIsModalOpen(true);
  };

  const componentContent = useContentLocalizer(localization);

  const dateContent = React.useMemo(() => {
    return componentContent.formatString(componentContent.period, {
      startDate: toUTCDateString(getFirstDayOfSpecifiedMonth(dateToSearch), componentContent.locale, true),
      endDate: toUTCDateString(
        currentMonth ? new Date() : getLastDayOfSpecifiedMonth(dateToSearch),
        componentContent.locale,
      ),
    });
  }, [dateToSearch]);

  return (
    <ConsolidatedHeader>
      <bds-grid direction="row" justify-content="space-between" margin="b-1">
        <bds-grid direction="column" justify-content="space-between">
          <bds-grid direction="row" margin="b-1">
            <BdsTypo margin={false} tag="h3" variant="fs-24" bold="bold">
              {infoHeader}
            </BdsTypo>
          </bds-grid>
          <BdsTypo variant="fs-14" lineHeight="plus">
            {dateContent}
          </BdsTypo>
        </bds-grid>
        <bds-grid direction="row" justify-content="space-between">
          {filter1}
          {filter2}
        </bds-grid>
      </bds-grid>
      <CustomModal
        open={isModalOpen}
        clickY={clickPosition.y}
        modalTitle={modalTitle}
        delivered={modalDelivered}
        paids={modalPaids}
        free={modalFree}
        entryPoint={modalEntryPoint}
        service={modalService}
        modalAction={modalAction}
        onClose={() => setIsModalOpen(false)}
      />
      {middleInfoContent && (
        <BdsTypo variant="fs-14" lineHeight="plus">
          {middleInfoContent}
        </BdsTypo>
      )}
      {showConsolidatedBorder && <ConsolidatedBorder className="color-surface-3" />}
      {endInfoContent && (
        <ConsolidatedEndInfo>
          <BdsTypo variant="fs-14" lineHeight="plus">
            {endInfoContent} <ModalOpenButton onClick={handleLearnMoreClick}>{learnMore}</ModalOpenButton>
          </BdsTypo>
        </ConsolidatedEndInfo>
      )}
    </ConsolidatedHeader>
  );
};

ConsolidatedHeaderComponent.propTypes = {
  infoHeader: PropTypes.string.isRequired,
  dateToSearch: PropTypes.instanceOf(Date).isRequired,
  currentMonth: PropTypes.bool.isRequired,
  showConsolidatedBorder: PropTypes.bool,
  middleInfoContent: PropTypes.string,
  endInfoContent: PropTypes.string,
  learnMore: PropTypes.string,
  modalContent: PropTypes.object,
};

export { ConsolidatedHeaderComponent };
